// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import { Portal } from "@mui/base";
import { v4 as uuidv4 } from "uuid";
import CachedIcon from "@mui/icons-material/Cached";
// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Link,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CallApi } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "title", label: "Title", alignRight: false },
  { id: "priceType", label: "Price Type", alignRight: false },
  { id: "dimensionType", label: "Dimension Type", alignRight: false },
  { id: "descr", label: "Description", alignRight: false },
  { id: "items", label: "Items", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Steps() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [dialogMode, setDialogMode] = useState("add");
  const [stepTitle, setStepTitle] = useState("");
  const [stepTitleErrorText, setStepTitleErrorText] = useState("");
  const [stepDes, setStepDes] = useState("");
  const [stepDesErrorText, setStepDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  // const [obsoletedValue, setObsoletedValue] = useState("");
  // const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [priceTypeList, setPriceTypeList] = useState([]);
  const [priceTypeValue, setPriceTypeValue] = useState("");
  const [priceTypeValueErrorText, setPriceTypeValueErrorText] = useState("");
  const [dimensionTypeList, setDimensionTypeList] = useState([]);
  const [dimensionTypeValue, setDimensionTypeValue] = useState("");
  const [dimensionTypeValueErrorText, setDimensionTypeValueErrorText] =
    useState("");
  const [config, setConfig] = useState(null);
  const [currentStepItem, setCurrentStepItem] = useState({
    id: "",
    title: "",
  });

  const [copyToDialog, setCopyToDialog] = useState(false);
  const [copyToPath, setCopyToPath] = useState([]);
  const [allSteps, setAllSteps] = useState([]);

  const navigate = useNavigate();

  // const stepTitleTextField = useRef(null);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
    };
    setDataLoading(true);
    CallApi("getConfig", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setConfig(result.result);
          setPriceTypeList(
            result.result.priceTypes.filter(
              (item) => item.id !== "formulairr" && item.id !== "formulasm"
            )
          );
          setDimensionTypeList(result.result.dimensionTypes);
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  useEffect(() => {
    if (config) {
      getAllSteps1();
    }
  }, [config]);

  useEffect(() => {
    if (tableData.length > 0) setDataLoading(false);
  }, [tableData]);

  const getAllSteps1 = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 100000,
    };
    CallApi("getAllSteps", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setAllSteps(result.result);
          setCopyToPath([{ id: uuidv4(), list: result.result, value: "" }]);
          getAllSteps();
        }
      } catch (error) {
        console.log("error: ", error);
        setDataLoading(false);
      }
    });
  };

  const getAllSteps = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("getAllSteps", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          let res = [...result.result];
          res.forEach((element) => {
            config.priceTypes.forEach((element1) => {
              if (element.priceType === element1.id) {
                element.priceTypeTitle = element1.title;
              }
            });

            config.dimensionTypes.forEach((element1) => {
              if (element.dimensionType === element1.id) {
                element.dimensionTypeTitle = element1.title;
              }
            });
          });
          setTableData(res);
          setTotalItems(result.paginateInfo.totalItems);
        }
        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
        setDataLoading(false);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) getAllSteps();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) stepTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    setStepTitle("");
    setStepTitleErrorText("");
    setStepDes("");
    setPriceTypeValue([priceTypeList[0].id]);
    setDimensionTypeValue([dimensionTypeList[0].id]);
    setMinHeight("");
    setMaxHeight("");
    setMinWidth("");
    setMaxWidth("");
    // setObsoletedValue("");
    setPriceTypeValueErrorText("");
    setDimensionTypeValueErrorText("");
    setMinHeightErrorText("");
    setMinWidthErrorText("");
    setMaxHeightErrorText("");
    setMaxWidthErrorText("");
    // setObsoletedValueErrorText("");

    setAddDialogOpen(true);
  };

  const addStep = () => {
    if (!stepTitle) {
      setStepTitleErrorText("Step title cannot be empty");
      return;
    } else {
      setStepTitleErrorText("");
    }

    if (!priceTypeValue) {
      setPriceTypeValueErrorText("Price type cannot be empty");
      return;
    } else {
      setPriceTypeValueErrorText("");
    }

    if (!dimensionTypeValue) {
      setDimensionTypeValueErrorText("Dimension type cannot be empty");
      return;
    } else {
      setDimensionTypeValueErrorText("");
    }
    if (dimensionTypeValue && dimensionTypeValue[0] !== "none") {
      if (!minHeight) {
        setMinHeightErrorText("Min height cannot be empty");
        return;
      } else {
        setMinHeightErrorText("");
      }

      if (!maxHeight) {
        setMaxHeightErrorText("Max height cannot be empty");
        return;
      } else {
        setMaxHeightErrorText("");
      }

      if (!minWidth) {
        setMinWidthErrorText("Min width cannot be empty");
        return;
      } else {
        setMinWidthErrorText("");
      }

      if (!maxWidth) {
        setMaxWidthErrorText("Max width cannot be empty");
        return;
      } else {
        setMaxWidthErrorText("");
      }
    }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      title: stepTitle ? stepTitle : "",
      descr: stepDes ? stepDes : "",
      priceType: priceTypeValue ? priceTypeValue[0] : null,
      dimensionType: dimensionTypeValue ? dimensionTypeValue[0] : null,
      dimensionAttr:
        dimensionTypeValue && dimensionTypeValue[0] !== "none"
          ? {
              height: { min: minHeight, max: maxHeight },
              width: { min: minWidth, max: maxWidth },
            }
          : null,
      // obsoletedPriceWith: obsoletedValue ? obsoletedValue[0] : null,
    };
    let apiname = "createNewStep";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        stepId: currentStepItem._id,
        title: stepTitle ? stepTitle : "",
        descr: stepDes ? stepDes : "",
        priceType: priceTypeValue ? priceTypeValue[0] : null,
        dimensionType: dimensionTypeValue ? dimensionTypeValue[0] : null,
        dimensionAttr:
          dimensionTypeValue && dimensionTypeValue[0] !== "none"
            ? {
                height: { min: minHeight, max: maxHeight },
                width: { min: minWidth, max: maxWidth },
              }
            : null,
        // obsoletedPriceWith: obsoletedValue ? obsoletedValue[0] : null,
      };
      apiname = "updateStep";
    }

    console.log(data);
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllSteps();
            setSnackType("success");

            if (apiname === "createNewStep")
              setSnackbarMessage(
                "'" + stepTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + stepTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentStepItem(item);
      setDialogMode("update");
      setStepTitle(item.title);
      setStepDes(item.descr);
      setPriceTypeValue(
        item.priceType ? [item.priceType] : [priceTypeList[0].id]
      );
      setDimensionTypeValue(
        item.dimensionType ? [item.dimensionType] : [dimensionTypeList[0].id]
      );
      if (item.dimensionAttr) {
        setMinHeight(item.dimensionAttr.height.min);
        setMaxHeight(item.dimensionAttr.height.max);
        setMinWidth(item.dimensionAttr.width.min);
        setMaxWidth(item.dimensionAttr.width.max);
      } else {
        setMinHeight("");
        setMaxHeight("");
        setMinWidth("");
        setMaxWidth("");
      }
      // setObsoletedValue(
      //   item.obsoletedPriceWith ? [item.obsoletedPriceWith] : ""
      // );
      setStepTitleErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentStepItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const onCopyToItem = (item) => {
    if (!buttonDisabled) {
      setCopyToPath([{ id: uuidv4(), list: allSteps, value: "" }]);
      setCurrentStepItem(item);
      setCopyToDialog(true);
    }
  };

  const handleChangePriceType = (event) => {
    const {
      target: { value },
    } = event;
    setPriceTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeDimensionType = (event) => {
    const {
      target: { value },
    } = event;
    setDimensionTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  // const handleChangeObsoleted = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setObsoletedValue(typeof value === "string" ? value.split(",") : value);
  // };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      stepId: currentStepItem._id,
    };

    console.log(data);

    setButtonDisabled(true);
    CallApi("removeStep", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllSteps();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const loadSubCat = () => {
    findItemswithPath();
  };

  const findItemswithPath = () => {
    let parents = [];

    copyToPath.forEach((element) => {
      parents.push(element.value);
    });

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      parentList: parents,
      page: 0,
      count: 100000,
    };
    console.log(data);
    setButtonDisabled(true);
    CallApi("findItemswithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          // setTableData(result.result);
          if (result.result.length > 0) {
            let path = JSON.parse(JSON.stringify(copyToPath));
            path.push({ id: uuidv4(), list: result.result, value: "" });
            setCopyToPath(path);
          } else {
            setSnackType("error");
            setSnackbarMessage("there is no step-item in this step");
            setSnackbarOpen(true);
          }
        }

        setButtonDisabled(false);
      } catch (error) {
        console.log("error: ", error);
        setButtonDisabled(false);
      }
    });
  };

  const confirmCopy = () => {
    let i = 0;
    let index = -1;
    let destinationSIPath = [];
    copyToPath.forEach((element) => {
      if (!element.value && index === -1) index = i;
      destinationSIPath.push(element.value);
      i++;
    });

    if (index > -1) {
      if (index === 0) {
        setSnackType("error");
        setSnackbarMessage("please select destination step");
        setSnackbarOpen(true);
      } else {
        setSnackType("error");
        setSnackbarMessage("please select step item " + index);
        setSnackbarOpen(true);
      }

      return;
    }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      originStepId: currentStepItem._id,
      destinationStepId: copyToPath[0].value,
      originSIPath: "," + currentStepItem._id + ",",
      destinationSIPath: "," + destinationSIPath.toString() + ",",
    };

    console.log(data);
    // return;
    setButtonDisabled(true);
    CallApi("copySIs", "post", data)
      .then((result) => {
        setButtonDisabled(false);
        try {
          console.log(result);
          setSnackType("success");
          setSnackbarMessage("step items successfully copied");
          setSnackbarOpen(true);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Steps | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Steps
            </Typography>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Step
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const {
                          _id,
                          title,
                          priceTypeTitle,
                          dimensionTypeTitle,
                          descr,
                          createdAt,
                        } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {title}
                              </Typography>
                            </TableCell>
                            <TableCell>{priceTypeTitle}</TableCell>
                            <TableCell>{dimensionTypeTitle}</TableCell>
                            <TableCell>{descr ? descr : "-"}</TableCell>
                            {/* <TableCell>{createdAt}</TableCell> */}
                            <TableCell align="left">
                              <Link href={"/steps/" + _id}>
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                              {/* {status === 1 && (
                                  <Stack
                                    direction="row"
                                    spacing={0.5}
                                    divider={
                                      <Divider
                                        orientation="vertical"
                                        flexItem
                                      />
                                    }
                                    alignItems="center"
                                  >
                                    <Button
                                      onClick={() => {
                                        onAction(row, "accepting");
                                      }}
                                      variant="outlined"
                                      color="primary"
                                      startIcon={<CheckIcon />}
                                    >
                                      Accept
                                    </Button>

                                    <Button
                                      onClick={() => {
                                        onAction(row, "rejecting");
                                      }}
                                      variant="outlined"
                                      color="error"
                                      startIcon={<DoNotDisturbAltIcon />}
                                    >
                                      Reject
                                    </Button>
                                  </Stack>
                                )} */}

                              {/* {status !== 1 && (
                                  <Chip
                                    label={statusTitle}
                                    color={
                                      status === 1
                                        ? "warning"
                                        : status === 2
                                        ? "primary"
                                        : "error"
                                    }
                                  />
                                )} */}
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                                onCopyTo={() => onCopyToItem(row)}
                                hasCopyTo
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Step</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentStepItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog
        sx={{ p: 2, mt: 2 }}
        open={infoDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          setInfoDialogOpen(false);
        }}
      >
        <DialogTitle>
          {"More info about '" + currentLocItem.title + "': "}
        </DialogTitle>

        <DialogContent sx={{ maxWidth: "400px" }}>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Farm Type: </Typography>
            <Typography variant="paragraph">
              {currentLocItem.farmType}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Address: </Typography>
            <Typography variant="paragraph">
              {currentLocItem.address}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Area: </Typography>
            <Typography variant="paragraph">{currentLocItem.area}</Typography>
          </Stack>

          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Latitude: </Typography>
            <Typography variant="paragraph">{currentLocItem.lat}</Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Longitude: </Typography>
            <Typography variant="paragraph">{currentLocItem.lon}</Typography>
          </Stack>

          <Stack direction="column" sx={{ width: "100%" }}>
            <Box
              sx={{
                width: "100%",
                minHeight: "1px",
                backgroundColor: "var(--gray2)",
              }}
              mt={3}
              mb={1}
            />
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                onClick={() => {
                  setInfoDialogOpen(false);
                }}
                variant="outlined"
                disabled={buttonDisabled}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog> */}

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Step" : "Edit Step"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          {/* <Stack direction="row" spacing={1} style={{ alignItems: "center" }}>
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--mainColor)",
                flex: "1",
              }}
            />
            <div>or</div>
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--mainColor)",
                flex: "1",
              }}
            />
          </Stack> */}

          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={stepTitle}
            // inputRef={stepTitleTextField}
            onChange={(e) => setStepTitle(e.target.value)}
            disabled={buttonDisabled}
            // disabled={addStepLoading}
            helperText={stepTitleErrorText}
            error={stepTitleErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Description"
            value={stepDes}
            onChange={(e) => setStepDes(e.target.value)}
            disabled={buttonDisabled}
            helperText={stepDesErrorText}
            error={stepDesErrorText ? true : false}
          />

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled}
            error={priceTypeValueErrorText ? true : false}
          >
            <InputLabel>Price Type</InputLabel>
            <Select
              value={priceTypeValue ? priceTypeValue : ""}
              onChange={handleChangePriceType}
              input={<OutlinedInput label="Price Type" />}
              MenuProps={MenuProps}
            >
              {priceTypeList.map((pt) => (
                <MenuItem key={pt.id} value={pt.id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{priceTypeValueErrorText}</FormHelperText>
          </FormControl>

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled}
            error={dimensionTypeValueErrorText ? true : false}
          >
            <InputLabel>Dimension Type</InputLabel>
            <Select
              value={dimensionTypeValue ? dimensionTypeValue : ""}
              onChange={handleChangeDimensionType}
              input={<OutlinedInput label="Dimension Type" />}
              MenuProps={MenuProps}
            >
              {dimensionTypeList.map((pt) => (
                <MenuItem key={pt.id} value={pt.id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{dimensionTypeValueErrorText}</FormHelperText>
          </FormControl>

          {dimensionTypeValue[0] === "limit" && (
            <Stack direction="row" spacing={1} mb={2}>
              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Min Height(mm)"
                value={minHeight}
                onChange={(e) => setMinHeight(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={minHeightErrorText}
                error={minHeightErrorText ? true : false}
              />

              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Max Height(mm)"
                value={maxHeight}
                onChange={(e) => setMaxHeight(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={maxHeightErrorText}
                error={maxHeightErrorText ? true : false}
              />
            </Stack>
          )}

          {dimensionTypeValue[0] === "limit" && (
            <Stack direction="row" spacing={1} mb={2}>
              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Min Width(mm)"
                value={minWidth}
                onChange={(e) => setMinWidth(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={minWidthErrorText}
                error={minWidthErrorText ? true : false}
              />

              <TextField
                fullWidth
                autoFocus
                type="text"
                label="Max Width(mm)"
                value={maxWidth}
                onChange={(e) => setMaxWidth(e.target.value)}
                disabled={
                  buttonDisabled ||
                  dimensionTypeValue.length < 1 ||
                  dimensionTypeValue[0] === "none"
                }
                helperText={maxWidthErrorText}
                error={maxWidthErrorText ? true : false}
              />
            </Stack>
          )}

          {/* <FormControl
            sx={{ mb: 2, mt: 1 }}
            fullWidth
            disabled={buttonDisabled}
            error={obsoletedValueErrorText ? true : false}
          >
            <InputLabel>Obsoleted Price With</InputLabel>
            <Select
              value={obsoletedValue ? obsoletedValue : ""}
              onChange={handleChangeObsoleted}
              input={<OutlinedInput label="Obsoleted Price With" />}
              MenuProps={MenuProps}
            >
              {tableData.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{obsoletedValueErrorText}</FormHelperText>
          </FormControl> */}

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addStep}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={copyToDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setCopyToDialog(false);
        }}
      >
        <DialogTitle>Specify the destination path</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          {copyToPath.map((item, i) => {
            return (
              <FormControl
                key={item.id}
                sx={{ mb: 2, mt: 1 }}
                fullWidth
                disabled={buttonDisabled}
                // error={productValueErrorText ? true : false}
              >
                <InputLabel>{i < 1 ? "Step" : "Step Item " + i}</InputLabel>
                <Select
                  value={item.value ? item.value : ""}
                  onChange={(e) => {
                    let path = JSON.parse(JSON.stringify(copyToPath));
                    let index = 0;
                    let counter = 0;
                    path.forEach((element) => {
                      if (element.id === item.id) {
                        element.value = e.target.value;
                        index = counter;
                      }
                      counter++;
                    });

                    if (path.length - 1 > index) path.splice(index + 1);

                    setCopyToPath(path);
                  }}
                  input={
                    <OutlinedInput
                      label={i < 1 ? "Product" : "Product Step " + i}
                    />
                  }
                  MenuProps={MenuProps}
                >
                  {item.list.map((pt) => (
                    <MenuItem key={pt._id} value={pt._id}>
                      {pt.title}
                    </MenuItem>
                  ))}
                </Select>
                {/* <FormHelperText>{productValueErrorText}</FormHelperText> */}
              </FormControl>
            );
          })}
          {copyToPath[copyToPath.length - 1]?.value && (
            <Button
              fullWidth
              sx={{ mb: 1 }}
              onClick={loadSubCat}
              variant="outlined"
              disabled={buttonDisabled}
              startIcon={<CachedIcon />}
              component="label"
            >
              Load Step Items
            </Button>
          )}

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={confirmCopy}
            variant="contained"
            disabled={buttonDisabled}
          >
            Copy
          </Button>
          <Button
            onClick={() => setCopyToDialog(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
